var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _vm.success
          ? _c("i", {
              staticClass: "fal fa-check-circle -status-accepted fa-4x"
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "my-4" }, [
          _vm._v("\n        " + _vm._s(_vm.text) + "\n      ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e77c0b0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e77c0b0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/LineProfessionalLoginCallback.vue
// module id = 1650
// module chunks = 0